export default "__VITE_ASSET__e1536c5a__"